import React, { ReactElement, WeakValidationMap } from 'react';
import { forgeClassHelper } from '../utils/classes';
import PropTypes from 'prop-types';

const classes = forgeClassHelper('list');

/**
 * ListItem
 *
 * A component to render an unordered list item.
 * @documentedBy List
 */
const ListItem = ({ children, ...rootProps }: ListItemProps): ReactElement => {
  return (
    <li {...rootProps} {...classes({ extra: rootProps.className, element: 'item' })}>
      {children}
    </li>
  );
};

export interface ListItemProps extends React.HTMLAttributes<HTMLLIElement> {
  /** Content to display inside ListItem */
  children?: React.ReactNode;

  /** Adds a class to the root element of the component */
  className?: string;
}

const listItemPropTypes: WeakValidationMap<ListItemProps & { '...rest': unknown }> = {
  /** Content to display inside ListItem */
  children: PropTypes.node,
  /** Adds a class to the root element of the component */
  className: PropTypes.string,
  /** Passthrough props */
  '...rest': PropTypes.any,
};

ListItem.propTypes = listItemPropTypes;

export default ListItem;
